import { useCallback, useEffect, useState } from 'react';
export const useTabActive = () => {
  const _useState = useState(true),
    visibilityState = _useState[0],
    setVisibilityState = _useState[1];
  const handleVisibilityChange = useCallback(() => {
    setVisibilityState(document.visibilityState === 'visible');
  }, []);
  useEffect(() => {
    document.addEventListener('visibilitychange', handleVisibilityChange);
    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, [handleVisibilityChange]);
  return visibilityState;
};
//# sourceMappingURL=useTabActive.js.map